angular.module('app')
	.value('hostUrl', '/api/')
	.value('site_url', '/application/')

	.factory('httpErrorInterceptor', function ($q, $window, $injector, $timeout, $rootScope, hostUrl) {
		var timeouts = [];
		var openingTagRegex = new RegExp(/(<|&lt;)(\w)/g);

		$rootScope.$on('cancelHttpTimeouts', function () {
			angular.forEach(timeouts, function (t) {
				$timeout.cancel(t);
			});
			timeouts = [];
			var $http = $injector.get('$http');
			return $http.get(hostUrl + '2/Status', {
				failed: true
			});
		});

		function clearCompletedTimeouts() {
			var newTimeouts = [];
			angular.forEach(timeouts, function (t) {
				if (t.$$state.status == 0) {
					newTimeouts.push(t);
				}
			});
			timeouts = newTimeouts;
		}

		function handleOpeningTagInRequestBody(config) {
			if (config && ['PUT', 'POST', 'PATCH'].includes(config.method) && _.isObject(config.data) && config.url.indexOf('EmailTemplate') === -1 && !config.headers.isFileUpload) {
				config.data = JSON.parse(JSON.stringify(config.data).replace(openingTagRegex, '$1&#8288;$2'));
			}
		}

		return {
			'request': function (config) {
				config.retryTime = config.retryTime ? config.retryTime : 1000;
				handleOpeningTagInRequestBody(config);
				// CSRF HEADER
				config.headers['XSRF-TOKEN'] = 'LDNA';
				return config || $q.when(config);
			},

			'response': function (response) {
				if (response.config.failed) {
					location.reload();
				}
				return response;
			},

			'responseError': function (rejection) {
				// Unauthorized, relogin
				if (rejection.status === 401) {
					var locationHash = window.location.hash || '';
					if (locationHash.indexOf(' ') > -1) {
						// LEAN-8336 - Sometimes 'Buyer%20Performance' was coming in here as 'Buyer Performance'
						locationHash = locationHash.replace(/ /g, '%20');
					}
					var requestedPage = $window.location.pathname + $window.location.search + locationHash;
					$window.location.href = $window.location.protocol + '//' + $window.location.hostname + ($window.location.port ? ':' + $window.location.port : '') + '/auth/1/login?r=' + encodeURIComponent(requestedPage);
				}
				// Forbidden, they don't have access to a certain page
				if (rejection.status === 403) {
					if (rejection.headers() && rejection.headers()['x-source-ip-address-forbidden']) {
						if ($window.location.hash.indexOf('#/unauthorized-ip-address') !== 0) {
							$window.location.href = $window.location.protocol + '//' + $window.location.host + '/application/f/home.html#/unauthorized-ip-address?ip=' + rejection.headers()['x-source-ip-address-forbidden'];
						}
					} else {
						$window.location.href = $window.location.protocol + '//' + $window.location.host + '/application/f/home.html#/unauthorized';
					}
				}
				if (rejection.status === 0 && rejection.config && rejection.config.timeout && rejection.config.timeout.isUserCancelled) {
					return $q.reject(rejection);
				}
				// This is for data refresh 503s
				if (rejection.status === 503 && rejection.data && rejection.data.error &&
					rejection.data.error === 'Data is currently being refreshed, please try again later.') {
					return $q.reject(rejection);
				}
				// TIMEOUT/Network Issue/Server down
				if (rejection.status === 0 || rejection.status === 503 || rejection.status >= 12000) {
					if (rejection.config.failed) {
						var timeout = $timeout(function () {
							rejection.config.retryTime = rejection.config.retryTime * 2;
							rejection.config.retryTime = rejection.config.retryTime > 5 * 60 * 1000 ? 5 * 60 * 1000 : rejection.config.retryTime;
							var $http = $injector.get('$http');
							$rootScope.connectionLost = true;
							$rootScope.retryTime = rejection.config.retryTime;
							$rootScope.$broadcast('connectionLost');
							rejection.config.failed = true;
							return $http(rejection.config);
						}, rejection.config.retryTime);
					}

					clearCompletedTimeouts();
					if (rejection.config.failed) {
						timeouts.push(timeout);
					} else {
						$rootScope.$broadcast('cancelHttpTimeouts');
					}

				}
				return $q.reject(rejection);
			}
		};
	})

	.directive('focusMe', function ($timeout) {
		return {
			scope: {
				trigger: '=focusMe'
			},
			link: function (scope, element) {
				scope.$watch('trigger', function (value) {
					if (value === true) {
						element[0].focus();
						scope.trigger = false;
					}
				});
			}
		};
	})

	.directive('itemDrilldownCheck', function ($document, slideInModalService) {
		return {
			link: function ($scope, $element, $attributes) {
				$document.on('click', function (event) {
					var $target = jQuery(event.target);
					var $activeElement = jQuery(event.currentTarget.activeElement);
					var globalSearchOpen = $('.global-item-search').hasClass('open');
					var settingsDropdownOpen = $('#settingsDropdown').hasClass('open');
					if (
						!$target.attr('download') &&
						!settingsDropdownOpen &&
						!globalSearchOpen &&
						$target.closest('body').length && // don't close modal if element was removed from dom
						!$target.closest('.modal').length &&
						!$target.closest('.global-item-search').length &&
						!$target.closest('#settingsDropdown').length &&
						!$target.closest('.ui-select-choices-row-inner').length &&
						!$target.closest('.ui-select-container').length &&
						!$target.closest('.inlineEditDiv').length &&
						!$target.closest('.uib-datepicker-popup').length &&
						!$target.closest('.MuiBackdrop-root').length &&
						!$target.closest('.MuiPopover-root').length &&
						!$target.closest('.MuiAutocomplete-popper').length &&
						!$target.closest('.MuiDialog-container').length &&
						!$target.closest('#reactToastMessage').length &&
						!$target.closest('#documentUploadForm').length &&
						!$target.closest('.MuiCalendarPicker-root').length &&
						!($activeElement && $activeElement.closest('#unableToFixDropdown').length) &&
						!($activeElement && $activeElement.closest('#menu-unableToFixReason').length) &&
						!($activeElement && $activeElement.closest('.MuiDialog-container').length) &&
						!($activeElement && $activeElement.closest('.MuiSnackbar-root').length) &&
						!($activeElement && $activeElement.find('#documentUploadForm').length) &&
						!($activeElement && $activeElement.closest('.MuiPaper-root').length && !$activeElement.closest('.MuiDrawer-paper').length) &&
						(typeof $target.parent().parent()[0] !== 'undefined' &&
						!_.includes($target.parent().parent()[0].id, 'datepicker'))
					) {
						if (jQuery('.modal').length > 0) {
							jQuery('.inlineEditDiv').unbind();
							jQuery('.inlineEditDiv').remove();
							slideInModalService.closeModal();
						}
					}
				});
			}
		};
	})

	.service('slideInModalService', function ($rootScope, $uibModal, $timeout) {
		var self = this;
		var instance;

		self.openModal = function (options) {
			options['windowTopClass'] = 'right';
			options['windowClass'] = 'item-modal';
			options.backdrop = false;
			instance = $uibModal.open(options);
			return instance;
		};

		self.closeModal = function (isInitialClose) {
			$rootScope.$broadcast('itemDrilldownClosed', { isInitialClose: isInitialClose });
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			if (instance) {
				instance.close();
				instance = undefined;
			}
		};

		self.modalIsOpen = function () {
			return !!instance;
		};
	})

	.service('notificationService', function ($http, $rootScope, $timeout, URLS) {
		var self = this;
		self.notificationObject = {};
		return {
			getUnreadInventoryActions: getUnreadInventoryActions,
			getNotificationObject: getNotificationObject,
			decreaseNotificationCount: decreaseNotificationCount,
			getDeploymentId: getDeploymentId,
			setAutomaticReloadOfUnreadInventoryActions: setAutomaticReloadOfUnreadInventoryActions
		};

		function getUnreadInventoryActions(doNotCreateTimeout) {
			var url = URLS.host + URLS.prefix + globalConfig.factory.id + '/InventoryActions/Unread';
			return $http.get(url)
				.then(getUnreadInventoryActionsComplete, getUnreadInventoryActionsFailed);

			function getUnreadInventoryActionsComplete(response) {
				if (response && response.data) {
					angular.forEach(['openInventoryOpportunities', 'openProjectTasks'], function (type) {
						if (response.data[type]) {
							self.notificationObject[type] = response.data[type];
						} else { 
							self.notificationObject[type] = 0;
						}
					});
					
				} else {
					self.notificationObject.unreadNotifications = 0;
					self.notificationObject.openInventoryOpportunities = 0;
					self.notificationObject.openProjectTasks = 0;
				}
				if (!doNotCreateTimeout) { 
					setAutomaticReloadOfUnreadInventoryActions();
				}
			}

			function getUnreadInventoryActionsFailed(error) {
				self.notificationObject.unreadNotifications = 0;
				self.notificationObject.openInventoryOpportunities = 0;
				self.notificationObject.openProjectTasks = 0;
				setAutomaticReloadOfUnreadInventoryActions();
			}
		}

		function getNotificationObject() {
			return self.notificationObject;
		}

		function decreaseNotificationCount() {
			self.notificationObject.unreadNotifications -= 1;
		}

		function getDeploymentId() {
			var url = '/application/deploymentId.json';
			return $http.get(url)
				.then(getDeploymentIdSuccess, getDeploymentIdFailed);

			function getDeploymentIdSuccess(response) {
				var deploymentId = window.LEANDNA_DEPLOYMENT_ID;
				if (deploymentId && deploymentId !== response.data.deploymentId) {
					$rootScope.refreshPage = true;
					return;
				}
				$timeout(getDeploymentId, 5 * 60 * 1000);
			}

			function getDeploymentIdFailed(error) {
				// do nothing
			}
		}

		function setAutomaticReloadOfUnreadInventoryActions() { 
			$timeout(function () {
				getUnreadInventoryActions();
			}, 5 * 60 * 1000);
		}
	})

	.service('globalConfigService', function ($http, hostUrl) {
		return {
			getGlobalConfig: getGlobalConfig,
			getAllFactoriesForUser: getAllFactoriesForUser,
			hideBrowserBannerForUser: hideBrowserBannerForUser
		};

		function getGlobalConfig() {
			return $http.get(hostUrl + '2/GlobalConfig')
				.then(getGlobalConfigComplete)
				.catch(getGlobalConfigFailed);

			function getGlobalConfigComplete(response) {
				return response.data;
			}

			function getGlobalConfigFailed(error) {
				return undefined;
			}
		}

		function getAllFactoriesForUser() {
			var url = hostUrl;
			url += '2/Dimensions/Factories?allCustomers=';
			url += globalConfig.user.profileType == 'SuperSystemAdministrator';
			url += '&opsFactNdx=';
			url += globalConfig.factory.id;
			url += '&appendCustomerName=true';

			return $http.get(url)
				.then(getAllFactoriesForUserComplete)
				.catch(getAllFactoriesForUserFailed);

			function getAllFactoriesForUserComplete(response) {
				return response.data;
			}

			function getAllFactoriesForUserFailed(error) {
				return [];
			}
		}

		function hideBrowserBannerForUser() {
			return $http.put(hostUrl + '2/HideBrowserBanner')
				.then(hideBrowserBannerForUserComplete)
				.catch(hideBrowserBannerForUserFailed);

			function hideBrowserBannerForUserComplete(response) {
				return response;
			}

			function hideBrowserBannerForUserFailed(error) {
				return error;
			}
		}
	});
